class DialogFunctions {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
  }

  confirm() {
    this.$mdDialog.hide(this.model);
  }

  close() {
    this.$mdDialog.cancel();
  }

  $onDestroy() {
    this.close();
  }
}

export default DialogFunctions;



// WEBPACK FOOTER //
// ./src/core/dialogFunctions.js